import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';

const ManualWorkout = () => {
    const navigate = useNavigate();
    const [backgroundImage, setBackgroundImage] = useState('');
    const [workoutData, setWorkoutData] = useState({
        date: new Date().toISOString().split('T')[0],
        workoutType: '',
        category: 'manual',
        exercises: [],
        duration: '',
        notes: '',
        difficulty: 'Medium'
    });
    const [currentExercise, setCurrentExercise] = useState({
        name: '',
        reps: '',
        sets: '',
        weight: '',
        notes: '',
        muscleGroup: ''
    });

    // All available images for background
    const allImages = [
        'albert-einstein.jpg', 'alexander-the-great.jpg', 'amelia-earhart.jpg', 'American-Horse.jpg',
        'attila-the-hun.jpg', 'Black-Hawk.jpg', 'Black-Kettle.jpg', 'blackbeard.jpg', 'Blue-Jacket.jpg',
        'boudica.jpg', 'captainamerica.jpg', 'che-guevara.jpg', 'Chief-Joseph.jpg', 'christopher-columbus.jpg',
        'cleopatra-vii.jpg', 'Cochise.jpg', 'Cornstalk.jpg', 'Crazy-Horse.jpg', 'date-masamune.jpg',
        'deadpool.jpg', 'Dull-Knife.jpg', 'edgar-allan-poe.jpg', 'emperor-meiji.jpg', 'ernest-shackleton.jpg',
        'fuma-kotaro.jpg', 'galileo-galilei.jpg', 'Gall.jpg', 'geisha-master.jpg', 'Geronimo.jpg',
        'hannibal-barca.jpg', 'hattori-hanzo.jpg', 'heros.jpg', 'honda-tadakatsu.jpg', 'ikebana-master.jpg',
        'ironman.jpg', 'isaac-newton.jpg', 'jiraiya.jpg', 'julius-caesar.jpg', 'kabuki-actor.jpg',
        'Kamiakin.jpg', 'kendo-master.jpg', 'king-leonidas.jpg', 'King-Philip-Metacomet.jpg', 'kyudo-archer.jpg',
        'Leschi.jpg', 'lewis-clark.jpg', 'Little-Turtle.jpg', 'Looking-Glass.jpg', 'Lozen.jpg',
        'Mangas-Coloradas.jpg', 'marco-polo.jpg', 'michelangelo.jpg', 'minamoto-yoritomo.jpg', 'minamoto-yoshitsune.jpg',
        'miyamoto-musashi.jpg', 'Nana.jpg', 'napoleon-bonaparte.jpg', 'nikola-tesla.jpg', 'noh-master.jpg',
        'oda-nobunaga.jpg', 'onmyoji-mystic.jpg', 'oscar-wilde.jpg', 'Osceola.jpg', 'p-t-barnum.jpg',
        'pablo-picasso.jpg', 'Pontiac.jpg', 'prince-shotoku.jpg', 'Pushmataha.jpg', 'Quanah-Parker.jpg',
        'rasputin.jpg', 'Red-Cloud.jpg', 'Roman-Nose.jpg', 'saito-hajime.jpg', 'sarutobi-sasuke.jpg',
        'Sequoyah.jpg', 'Sir-Agravaine-the-Proud.jpg', 'Sir-Balin-le-Savage.jpg', 'Sir-Bedivere-the-Bold.jpg',
        'Sir-Bors-de-Ganis.jpg', 'Sir-Brandiles-the-Bold.jpg', 'Sir-Brunor-le-Noir-The-Black-Knight.jpg',
        'Sir-Cador-of-Cornwall.jpg', 'Sir-Constantine-of-Britain.jpg', 'Sir-Dinadan-the-Humorous.jpg',
        'Sir-Dodinas-le-Savage.jpg', 'Sir-Gaheris-of-Orkney.jpg', 'Sir-Galahad-the-Pure.jpg',
        'Sir-Gareth-of-Orkney.jpg', 'Sir-Garlon-the-Invisible-Knight.jpg', 'Sir-Gawain-of-Orkney.jpg',
        'Sir-Kay-the-Seneschal.jpg', 'Sir-Lamorak-de-Galis.jpg', 'Sir-Lancelot-du-Lac.jpg',
        'Sir-Lucan-the-Butler.jpg', 'Sir-Marrok-the-Werewolf-Knight.jpg', 'Sir-Palamedes-the-Saracen.jpg',
        'Sir-Pelleas-the-Gentle.jpg', 'Sir-Pelleas-the-Younger.jpg', 'Sir-Pellimore-the-Questing-Beast-Hunter.jpg',
        'Sir-Percival-the-Welsh.jpg', 'Sir-Safir-the-Saracen.jpg', 'Sir-Segwarides-the-Jealous.jpg',
        'Sir-Tor-the-Bastard.jpg', 'Sir-Tristan-of-Lyonesse.jpg', 'Sir-William-Marshal-1st-Earl-of-Pembroke.jpg',
        'Sitting-Bull.jpg', 'sohei-monk.jpg', 'spartacus.jpg', 'spiderman.jpg', 'sumo-champion.jpg',
        'takeda-shingen.jpg', 'tea-master.jpg', 'Tecumseh.jpg', 'Ten-Bears.jpg', 'tengu-master.jpg',
        'theodore-roosevelt.jpg', 'thor.jpg', 'tokugawa-ieyasu.jpg', 'uesugi-kenshin.jpg',
        'v1.jpg', 'v10.jpg', 'v11.jpg', 'v12.jpg', 'v13.jpg', 'v14.jpg', 'v15.jpg', 'v16.jpg',
        'v17.jpg', 'v18.jpg', 'v19.jpg', 'v2.jpg', 'v20.jpg', 'v21.jpg', 'v22.jpg', 'v23.jpg',
        'v24.jpg', 'v25.jpg', 'v26.jpg', 'v27.jpg', 'v28.jpg', 'v29.jpg', 'v3.jpg', 'v30.jpg',
        'v31.jpg', 'v32.jpg', 'v33.jpg', 'v34.jpg', 'v35.jpg', 'v36.jpg', 'v37.jpg', 'v38.jpg',
        'v39.jpg', 'v4.jpg', 'v40.jpg', 'v41.jpg', 'v42.jpg', 'v43.jpg', 'v44.jpg', 'v45.jpg',
        'v46.jpg', 'v47.jpg', 'v48.jpg', 'v49.jpg', 'v5.jpg', 'v50.jpg', 'v51.jpg', 'v52.jpg',
        'v53.jpg', 'v54.jpg', 'v55.jpg', 'v56.jpg', 'v57.jpg', 'v58.jpg', 'v59.jpg', 'v6.jpg',
        'v60.jpg', 'v61.jpg', 'v62.jpg', 'v63.jpg', 'v64.jpg', 'v65.jpg', 'v66.jpg', 'v67.jpg',
        'v68.jpg', 'v69.jpg', 'v7.jpg', 'v70.jpg', 'v71.jpg', 'v72.jpg', 'v73.jpg', 'v74.jpg',
        'v75.jpg', 'v76.jpg', 'v77.jpg', 'v78.jpg', 'v79.jpg', 'v8.jpg', 'v80.jpg', 'v81.jpg',
        'v82.jpg', 'v83.jpg', 'v84.jpg', 'v85.jpg', 'v86.jpg', 'v87.jpg', 'v88.jpg', 'v9.jpg',
        'Victorio.jpg', 'vincent-van-gogh.jpg', 'wild-bill-hickok.jpg', 'wolfgang-amadeus-mozart.jpg',
        'wolverine.jpg', 'yamabushi-alt.jpg', 'yamabushi.jpg', 'zen-monk.jpg'
    ];

    // Muscle group options
    const muscleGroups = [
        'Chest', 'Back', 'Core', 'Shoulders', 'Legs', 'Arms', 'Other'
    ];

    // Common exercise suggestions with muscle groups
    const exerciseSuggestions = [
        { name: 'Push-ups', group: 'Chest' },
        { name: 'Pull-ups', group: 'Back' },
        { name: 'Squats', group: 'Legs' },
        { name: 'Lunges', group: 'Legs' },
        { name: 'Planks', group: 'Core' },
        { name: 'Burpees', group: 'Other' },
        { name: 'Mountain Climbers', group: 'Core' },
        { name: 'Jumping Jacks', group: 'Other' },
        { name: 'Sit-ups', group: 'Core' },
        { name: 'Crunches', group: 'Core' },
        { name: 'Deadlifts', group: 'Back' },
        { name: 'Bench Press', group: 'Chest' },
        { name: 'Rows', group: 'Back' },
        { name: 'Bicep Curls', group: 'Arms' },
        { name: 'Tricep Dips', group: 'Arms' },
        { name: 'Shoulder Press', group: 'Shoulders' },
        { name: 'Lateral Raises', group: 'Shoulders' },
        { name: 'Leg Press', group: 'Legs' },
        { name: 'Calf Raises', group: 'Legs' },
        { name: 'Russian Twists', group: 'Core' },
        { name: 'High Knees', group: 'Other' },
        { name: 'Butt Kicks', group: 'Other' },
        { name: 'Jump Squats', group: 'Legs' },
        { name: 'Push-up to T', group: 'Chest' },
        { name: 'Superman', group: 'Back' },
        { name: 'Glute Bridges', group: 'Legs' }
    ];

    // Workout type options
    const workoutTypes = [
        'Strength Training', 'Cardio', 'HIIT', 'Yoga', 'Pilates', 'Calisthenics',
        'Running', 'Cycling', 'Swimming', 'Cross Training', 'Stretching', 'Sports'
    ];

    // Select random background image on component mount
    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * allImages.length);
        const selectedImage = allImages[randomIndex];
        setBackgroundImage(`/assets/images/${selectedImage}`);
    }, []);

    // Handle input changes for workout data
    const handleWorkoutDataChange = (field, value) => {
        setWorkoutData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Auto-suggest muscle group based on exercise name
    const handleExerciseNameChange = (exerciseName) => {
        handleExerciseChange('name', exerciseName);

        // Auto-fill muscle group if exercise is in suggestions
        const suggestion = exerciseSuggestions.find(ex =>
            ex.name.toLowerCase() === exerciseName.toLowerCase()
        );
        if (suggestion) {
            handleExerciseChange('muscleGroup', suggestion.group);
        }
    };

    // Handle input changes for current exercise
    const handleExerciseChange = (field, value) => {
        setCurrentExercise(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Add exercise to workout
    const addExercise = () => {
        if (currentExercise.name && currentExercise.reps && currentExercise.muscleGroup) {
            setWorkoutData(prev => ({
                ...prev,
                exercises: [...prev.exercises, { ...currentExercise, id: Date.now() }]
            }));
            setCurrentExercise({
                name: '',
                reps: '',
                sets: '',
                weight: '',
                notes: '',
                muscleGroup: ''
            });
        } else {
            alert('Please fill in exercise name, reps, and muscle group!');
        }
    };

    // Remove exercise from workout
    const removeExercise = (exerciseId) => {
        setWorkoutData(prev => ({
            ...prev,
            exercises: prev.exercises.filter(ex => ex.id !== exerciseId)
        }));
    };

    // Save workout to localStorage
    const saveWorkout = () => {
        if (!workoutData.workoutType || workoutData.exercises.length === 0) {
            alert('Please add a workout type and at least one exercise!');
            return;
        }

        try {
            // Get existing workout history
            const existingWorkouts = JSON.parse(localStorage.getItem('savedWorkouts') || '[]');

            // Calculate muscle group distribution for progress graphs
            const muscleGroupCounts = {};
            workoutData.exercises.forEach(exercise => {
                const group = exercise.muscleGroup.toLowerCase();
                muscleGroupCounts[group] = (muscleGroupCounts[group] || 0) + 1;
            });

            // Create workout entry compatible with progress graphs
            const workoutEntry = {
                ...workoutData,
                id: Date.now(),
                completedAt: new Date().toISOString(),
                totalExercises: workoutData.exercises.length,
                totalSets: workoutData.exercises.reduce((sum, ex) => sum + (parseInt(ex.sets) || 1), 0),
                totalReps: workoutData.exercises.reduce((sum, ex) => sum + (parseInt(ex.reps) || 0), 0),
                muscleGroupCounts, // This helps with progress graph integration
                muscleGroups: Object.keys(muscleGroupCounts) // List of muscle groups worked
            };

            // Add to workout history
            existingWorkouts.push(workoutEntry);
            localStorage.setItem('savedWorkouts', JSON.stringify(existingWorkouts));

            alert('Workout saved successfully!');

            // Reset form
            setWorkoutData({
                date: new Date().toISOString().split('T')[0],
                workoutType: '',
                category: 'manual',
                exercises: [],
                duration: '',
                notes: '',
                difficulty: 'Medium'
            });

        } catch (error) {
            console.error('Error saving workout:', error);
            alert('Error saving workout. Please try again.');
        }
    };

    // Handle back navigation
    const handleBack = () => {
        try {
            soundManager.playButtonSound();
        } catch (error) {
            console.warn('Sound error:', error);
        }
        navigate(-1);
    };

    return (
        <div
            className="manual-workout-container"
            style={{
                backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #FF4444, #CC0000, #AA0000)'
            }}
        >
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0, 0, 0, 0.4)',
                zIndex: 1
            }}></div>

            <div style={{
                position: 'relative',
                zIndex: 2,
                padding: '20px',
                color: 'white'
            }}>
                <header style={{
                    textAlign: 'center',
                    marginBottom: '30px'
                }}>
                    <button
                        onClick={handleBack}
                        style={{
                            position: 'absolute',
                            top: '20px',
                            left: '20px',
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: '2px solid #FF4444',
                            color: 'white',
                            padding: '10px 20px',
                            borderRadius: '25px',
                            cursor: 'pointer',
                            fontWeight: 'bold'
                        }}
                    >
                        ← Back
                    </button>

                    <h1 style={{
                        fontSize: '3rem',
                        margin: '20px 0',
                        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                        background: 'linear-gradient(45deg, #FF4444, #FFF)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text'
                    }}>
                        📝 Manual Workout Entry
                    </h1>

                    <p style={{
                        fontSize: '1.2rem',
                        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.7)'
                    }}>
                        Log your custom workouts and track your progress
                    </p>
                </header>

                <div style={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    background: 'rgba(0, 0, 0, 0.7)',
                    borderRadius: '15px',
                    padding: '30px',
                    border: '2px solid #FF4444'
                }}>
                    {/* Workout Basic Info */}
                    <div style={{
                        marginBottom: '30px',
                        padding: '20px',
                        background: 'rgba(255, 68, 68, 0.1)',
                        borderRadius: '10px',
                        border: '1px solid #FF4444'
                    }}>
                        <h3 style={{
                            color: '#FF4444',
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            Workout Information
                        </h3>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: '15px'
                        }}>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontWeight: 'bold'
                                }}>
                                    Date:
                                </label>
                                <input
                                    type="date"
                                    value={workoutData.date}
                                    onChange={(e) => handleWorkoutDataChange('date', e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #FF4444',
                                        background: 'rgba(0, 0, 0, 0.8)',
                                        color: 'white',
                                        fontSize: '1rem'
                                    }}
                                />
                            </div>

                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontWeight: 'bold'
                                }}>
                                    Workout Type:
                                </label>
                                <select
                                    value={workoutData.workoutType}
                                    onChange={(e) => handleWorkoutDataChange('workoutType', e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #FF4444',
                                        background: 'rgba(0, 0, 0, 0.8)',
                                        color: 'white',
                                        fontSize: '1rem'
                                    }}
                                >
                                    <option value="">Select Workout Type</option>
                                    {workoutTypes.map(type => (
                                        <option key={type} value={type}>{type}</option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontWeight: 'bold'
                                }}>
                                    Duration (minutes):
                                </label>
                                <input
                                    type="number"
                                    value={workoutData.duration}
                                    onChange={(e) => handleWorkoutDataChange('duration', e.target.value)}
                                    placeholder="30"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #FF4444',
                                        background: 'rgba(0, 0, 0, 0.8)',
                                        color: 'white',
                                        fontSize: '1rem'
                                    }}
                                />
                            </div>

                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontWeight: 'bold'
                                }}>
                                    Difficulty:
                                </label>
                                <select
                                    value={workoutData.difficulty}
                                    onChange={(e) => handleWorkoutDataChange('difficulty', e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #FF4444',
                                        background: 'rgba(0, 0, 0, 0.8)',
                                        color: 'white',
                                        fontSize: '1rem'
                                    }}
                                >
                                    <option value="Easy">Easy</option>
                                    <option value="Medium">Medium</option>
                                    <option value="Hard">Hard</option>
                                    <option value="Extreme">Extreme</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Add Exercise Section */}
                    <div style={{
                        marginBottom: '30px',
                        padding: '20px',
                        background: 'rgba(255, 68, 68, 0.1)',
                        borderRadius: '10px',
                        border: '1px solid #FF4444'
                    }}>
                        <h3 style={{
                            color: '#FF4444',
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            Add Exercise
                        </h3>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                            gap: '15px',
                            marginBottom: '15px'
                        }}>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontWeight: 'bold'
                                }}>
                                    Exercise Name:
                                </label>
                                <input
                                    type="text"
                                    value={currentExercise.name}
                                    onChange={(e) => handleExerciseNameChange(e.target.value)}
                                    placeholder="e.g., Push-ups"
                                    list="exercise-suggestions"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #FF4444',
                                        background: 'rgba(0, 0, 0, 0.8)',
                                        color: 'white',
                                        fontSize: '1rem'
                                    }}
                                />
                                <datalist id="exercise-suggestions">
                                    {exerciseSuggestions.map(exercise => (
                                        <option key={exercise.name} value={exercise.name} />
                                    ))}
                                </datalist>
                            </div>

                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontWeight: 'bold'
                                }}>
                                    Muscle Group:
                                </label>
                                <select
                                    value={currentExercise.muscleGroup}
                                    onChange={(e) => handleExerciseChange('muscleGroup', e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #FF4444',
                                        background: 'rgba(0, 0, 0, 0.8)',
                                        color: 'white',
                                        fontSize: '1rem'
                                    }}
                                >
                                    <option value="">Select Muscle Group</option>
                                    {muscleGroups.map(group => (
                                        <option key={group} value={group}>{group}</option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontWeight: 'bold'
                                }}>
                                    Reps:
                                </label>
                                <input
                                    type="number"
                                    value={currentExercise.reps}
                                    onChange={(e) => handleExerciseChange('reps', e.target.value)}
                                    placeholder="10"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #FF4444',
                                        background: 'rgba(0, 0, 0, 0.8)',
                                        color: 'white',
                                        fontSize: '1rem'
                                    }}
                                />
                            </div>

                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontWeight: 'bold'
                                }}>
                                    Sets:
                                </label>
                                <input
                                    type="number"
                                    value={currentExercise.sets}
                                    onChange={(e) => handleExerciseChange('sets', e.target.value)}
                                    placeholder="3"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #FF4444',
                                        background: 'rgba(0, 0, 0, 0.8)',
                                        color: 'white',
                                        fontSize: '1rem'
                                    }}
                                />
                            </div>

                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontWeight: 'bold'
                                }}>
                                    Weight (optional):
                                </label>
                                <input
                                    type="text"
                                    value={currentExercise.weight}
                                    onChange={(e) => handleExerciseChange('weight', e.target.value)}
                                    placeholder="20 lbs"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #FF4444',
                                        background: 'rgba(0, 0, 0, 0.8)',
                                        color: 'white',
                                        fontSize: '1rem'
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '5px',
                                fontWeight: 'bold'
                            }}>
                                Exercise Notes:
                            </label>
                            <input
                                type="text"
                                value={currentExercise.notes}
                                onChange={(e) => handleExerciseChange('notes', e.target.value)}
                                placeholder="Any specific notes about form, tempo, etc."
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '5px',
                                    border: '1px solid #FF4444',
                                    background: 'rgba(0, 0, 0, 0.8)',
                                    color: 'white',
                                    fontSize: '1rem'
                                }}
                            />
                        </div>

                        <button
                            onClick={addExercise}
                            style={{
                                background: 'linear-gradient(135deg, #FF4444, #CC0000)',
                                border: '2px solid #FF4444',
                                color: 'white',
                                padding: '12px 25px',
                                borderRadius: '25px',
                                cursor: 'pointer',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                width: '100%',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            ➕ Add Exercise
                        </button>
                    </div>

                    {/* Exercise List */}
                    {workoutData.exercises.length > 0 && (
                        <div style={{
                            marginBottom: '30px',
                            padding: '20px',
                            background: 'rgba(255, 68, 68, 0.1)',
                            borderRadius: '10px',
                            border: '1px solid #FF4444'
                        }}>
                            <h3 style={{
                                color: '#FF4444',
                                marginBottom: '20px',
                                textAlign: 'center'
                            }}>
                                Workout Exercises ({workoutData.exercises.length})
                            </h3>

                            {workoutData.exercises.map((exercise, index) => (
                                <div key={exercise.id} style={{
                                    background: 'rgba(0, 0, 0, 0.5)',
                                    padding: '15px',
                                    borderRadius: '8px',
                                    marginBottom: '10px',
                                    border: '1px solid rgba(255, 68, 68, 0.3)',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: '10px'
                                }}>
                                    <div style={{ flex: 1, minWidth: '200px' }}>
                                        <strong style={{ color: '#FF4444' }}>
                                            {index + 1}. {exercise.name}
                                        </strong>
                                        <div style={{ fontSize: '0.9rem', marginTop: '5px' }}>
                                           <span style={{ color: '#FF4444', fontWeight: 'bold' }}>
                                               {exercise.muscleGroup}
                                           </span> • {exercise.reps} reps
                                            {exercise.sets && ` × ${exercise.sets} sets`}
                                            {exercise.weight && ` @ ${exercise.weight}`}
                                        </div>
                                        {exercise.notes && (
                                            <div style={{
                                                fontSize: '0.8rem',
                                                fontStyle: 'italic',
                                                color: '#ccc',
                                                marginTop: '3px'
                                            }}>
                                                {exercise.notes}
                                            </div>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => removeExercise(exercise.id)}
                                        style={{
                                            background: '#CC0000',
                                            border: 'none',
                                            color: 'white',
                                            padding: '8px 12px',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            fontSize: '0.9rem'
                                        }}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Workout Notes */}
                    <div style={{
                        marginBottom: '30px',
                        padding: '20px',
                        background: 'rgba(255, 68, 68, 0.1)',
                        borderRadius: '10px',
                        border: '1px solid #FF4444'
                    }}>
                        <h3 style={{
                            color: '#FF4444',
                            marginBottom: '15px',
                            textAlign: 'center'
                        }}>
                            Workout Notes
                        </h3>

                        <textarea
                            value={workoutData.notes}
                            onChange={(e) => handleWorkoutDataChange('notes', e.target.value)}
                            placeholder="How did the workout feel? Any observations, achievements, or areas for improvement?"
                            rows="4"
                            style={{
                                width: '100%',
                                padding: '15px',
                                borderRadius: '8px',
                                border: '1px solid #FF4444',
                                background: 'rgba(0, 0, 0, 0.8)',
                                color: 'white',
                                fontSize: '1rem',
                                resize: 'vertical',
                                fontFamily: 'inherit'
                            }}
                        />
                    </div>

                    {/* Save Button */}
                    <button
                        onClick={saveWorkout}
                        style={{
                            background: 'linear-gradient(135deg, #FF4444, #CC0000)',
                            border: '2px solid #FF4444',
                            color: 'white',
                            padding: '15px 30px',
                            borderRadius: '25px',
                            cursor: 'pointer',
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            width: '100%',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 8px rgba(255, 68, 68, 0.3)'
                        }}
                    >
                        💾 Save Workout
                    </button>
                </div>

                <footer style={{
                    textAlign: 'center',
                    marginTop: '40px',
                    padding: '20px',
                    background: 'rgba(0, 0, 0, 0.7)',
                    borderRadius: '15px',
                    border: '2px solid #FF4444'
                }}>
                    <p style={{ marginBottom: '10px' }}>
                        📊 Track any workout, anytime, anywhere!
                    </p>
                    <p style={{ fontSize: '0.9rem', color: '#ccc' }}>
                        Your manually logged workouts count towards all milestones and progress tracking.
                    </p>
                </footer>
            </div>
        </div>
    );
};

export default ManualWorkout;